<template>
  <component
    v-bind:is="$route.name === 'article' ? 'ArticleContent' : 'ArticleForm'"
    :product="product" />
</template>

<script>
import ArticleForm from '@/components/ArticleForm'
import ArticleContent from '@/components/ArticleContent'

export default {
  name: 'Article',
  props: { product: { type: Object, required: true } },
  components: {
    ArticleForm,
    ArticleContent
  }
}
</script>
